import { FC, memo, useState } from 'react';

import Footer from 'components/ImportCsv/Footer';
import Header from 'components/ImportCsv/Header';
import { stepContent } from 'components/ImportCsv/constants';
import { IModalProps } from 'components/Modal/constants';
import { ImportCsvStyled } from 'components/ImportCsv/styled';

const ImportCsv: FC<IModalProps> = ({ onModalClose }) => {
  const [step, setStep] = useState<number>(0);
  const [fileColumns, setFileColumns] = useState<string[]>([]);

  const StepComponent = stepContent[step];

  return (
    <ImportCsvStyled>
      <Header step={step} setStep={setStep} />
      <StepComponent step={step} setStep={setStep} fileColumns={fileColumns} setFileColumns={setFileColumns} />
      <Footer step={step} setStep={setStep} onModalClose={onModalClose} />
    </ImportCsvStyled>
  );
};

export default memo(ImportCsv);
